import React from "react";
import { useNavigate } from "react-router-dom";
function TopClientRisk({ table_data }) {
  const REACT_APP_PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const navigate = useNavigate();

  return (
    <>
      <style>
        {`
                    .table thead tr th {
                        white-space: normal !important;
                        word-wrap: break-word;
                        padding: 6px 8px;
                    }
                    
                    .table tbody tr td {
                    color : #202c4b;
                    }
                    
                `}
      </style>
      <div className="table-responsive">
        <table className="table table-hover mb-0">
          <thead>
            <tr>
              <th>Client Name</th>
              <th>Consolidated Risk Score</th>
              <th>BU Head</th>
            </tr>
          </thead>
          <tbody>
            {table_data?.length > 0 &&
              table_data.map((item, index) => (
                <tr key={index}>
                  <td>
                    <h6
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        navigate(
                          `/client/view/${item.company_id}`,
                        );
                      }}
                      className="fw-medium"
                    >
                      {item.company_name}
                    </h6>
                    <span className="badge badge-info badge-xs">
                      {item.industry}
                    </span>
                  </td>
                  <td>
                    <h6
                      className={`avatar avatar-sm avatar-rounded text-fixed-white fs-12 fw-medium ${
                        item.average_weighted_points < 80
                          ? "bg-success"
                          : "bg-danger"
                      }`}
                    >
                      {item.average_weighted_points}
                    </h6>
                  </td>
                  <td>
                    <span
                      className="avatar avatar-rounded"
                      title={item.role_manager}
                    >
                      <img
                        src={`${REACT_APP_PINE_BASE_URL}/files/media/${item.userpic}`}
                        className="border border-white"
                        alt={item.role_manager}
                      />
                    </span>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default TopClientRisk;
